import React, { useEffect, useState, useRef } from "react";
import "./dropdown.scss";
import { useLocation } from "react-router-dom";
import Loader from "../../common/loader/loader.tsx";

export interface MasterDataDropdownProps {
  items: MasterDataDropdownItem[];
  defaultOption?: string;
  inputValue: string;
  onChange?: (item: MasterDataDropdownItem) => void;
  onInputChange?: (inputValue: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

export interface MasterDataDropdownItem {
  name: string;
}

const MasterSearchDropdown: React.FC<MasterDataDropdownProps> = (props) => {
  const location = useLocation();
  const [isActive, setIsActive] = useState(false);
  const [selected, setSelected] = useState(props.defaultOption || "");

  const [page, setPage] = useState(1);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const selectedRef = useRef<HTMLDivElement>(null);
  const itemsPerPage = 12;

  useEffect(() => {
    setSelected(props.defaultOption || "");
  }, [props.defaultOption, props.items, location.pathname]);


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleItemChange = (item: MasterDataDropdownItem) => {
    setSelected(item.name);
    setIsActive(false);
    if (props.onChange) {
      props.onChange({ ...item, name: item.name });
    }
  };


  return (
    <div ref={dropdownRef} className="dropdown">
      <input
        type="text"
        value={props.inputValue}
        onClick={(e) => {
          e.stopPropagation();
          setIsActive(true);
        }}
        onChange={(e) => {
          if (props.onInputChange) {
            props.onInputChange(e.target.value);
          }
        }}
        placeholder={props.defaultOption}
        className="dropdown-input"
        disabled={props.disabled}
        style={{ width: "100%" }}
      />
      {props.items?.length > 0 && (
        <div
          className="dropdown-content"
          style={{ display: isActive ? "block" : "none" }}
        >
          {props.isLoading ? (
            <Loader />
          ) : (
            props.items.map((item, index) => (
              <div
                key={`${index}`}
                onClick={() => handleItemChange(item)}
                className={`item ${selected === item.name ? "item-selected" : ""
                  }`}
                ref={selected === item.name ? selectedRef : null}
                data-testid={item.name}
              >
                {item.name}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default MasterSearchDropdown;
